import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import Login from '../components/Login';
import { backendUrl } from '../App';

const LoginContainer = () => {
    const [loading, setLoading] = useState(false);
    const [logged, setLogged] = useState(false);
    const [token, setToken] = useState();
    const [loginError, setLoginError] = useState();

    const login = async (username, password) => {
        setLoading(true);
        const bodyData = {
            "username": username,
            "password": password
        };

        try {
            const request = new Request(`${backendUrl}/auth/login`, {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify(bodyData)
            });

            const response = await fetch(request);
            const token = await response.json();
            sessionStorage.setItem('rtvcrespoToken', token);

            setToken(token);
            setLoading(false);
            setLogged(true);
            setLoginError(false);
        } catch (error) { 
            setLoading(false);
            setLoginError(true);
            console.error(error);
        };
    }

    useEffect(() => {
        const token = sessionStorage.getItem('rtvcrespoToken');
        if(token){
            setLogged(true);
            setToken(token);
        }
    }, []);

    if(logged){
        return <Redirect to='/home'/>
    }

    return (
        <Login login={login} loading={loading} loginError={loginError}/>
    );
};

export default LoginContainer;


// WEBPACK FOOTER //
// ./src/containers/LoginContainer.js